import React from 'react';
import { Link } from 'react-router-dom';
import { MailIcon, PhoneIcon, MapPinIcon, GlobeIcon, InstagramIcon, ClockIcon, ArrowRightIcon } from 'lucide-react';
import { business, images } from '../data/business';
import { PageIntro } from '../components/PageIntro';
import { useSeo } from '../utils/seo';
export function Contact() {
  useSeo({
    title: 'Contact — Goelst International B.V., Modemweg 19 Amersfoort',
    description: 'Contactgegevens van Goelst International B.V. in Amersfoort: telefoon 0031 (0)33 303 5964, e-mail info@goelst-international.com, adres Modemweg 19 en openingstijden.',
    path: '/contact'
  });
  return <>
      <PageIntro breadcrumb="Contact" h1="Contact met Goelst International in Amersfoort" lead="Heeft u een vraag over gordijnrails, een project in voorbereiding of een tekening waar u met ons naar wilt kijken? Bel of mail ons kantoor aan de Modemweg. Op werkdagen reageren wij zo snel als het kan." meta="Maandag t/m vrijdag 09:00 – 18:00 · zaterdag en zondag gesloten" data-id="element-196" data-mp="17sbrir7dcvql" />

      <section className="border-b border-line bg-white" aria-labelledby="contactgegevens" data-id="element-197" data-mp="19gsam8xgqgem">
        <div className="mx-auto max-w-shell px-6 py-16 md:py-20" data-id="element-198" data-mp="1e7qrb9md5gie">
          <div className="grid gap-12 lg:grid-cols-[1.05fr_0.95fr] lg:gap-16" data-id="element-199" data-mp="1e8ioupzitobb">
            <div data-id="element-200" data-mp="1j5iks82npaop">
              <h2 id="contactgegevens" className="font-display text-3xl font-700 leading-[1.1] tracking-tightest text-ink md:text-[38px]" data-id="element-201" data-mp="1j622bnoe9x27">
                Onze gegevens
              </h2>
              <dl className="mt-10 divide-y divide-line border-y border-line" data-id="element-202" data-mp="vh96dr7rvp7l">
                <div className="flex gap-5 py-6" data-id="element-203" data-mp="vjlukm44ivt3">
                  <MapPinIcon className="mt-1 h-5 w-5 shrink-0 text-accent" aria-hidden="true" data-id="element-204" data-mp="10hdkjal7k7un" />
                  <div data-id="element-205" data-mp="26vcvaizi6n5s">
                    <dt className="text-[13px] uppercase tracking-[0.14em] text-ink-mute" data-id="element-206" data-mp="26vwc1wdf35i8">Bezoek- en postadres</dt>
                    <dd className="mt-2 text-[17px] leading-relaxed text-ink" data-id="element-207" data-mp="2bxlsjrjesbdp">
                      {business.name}
                      <br data-id="element-208" data-mp="1h8aicqo1uxnr" />
                      {business.address.street}
                      <br data-id="element-209" data-mp="1h80naoo5e0b7" />
                      {business.address.postalCode} {business.address.city}
                      <br data-id="element-210" data-mp="1w3gnzcj8gugk" />
                      {business.address.region}, {business.address.country}
                    </dd>
                    <dd className="mt-3" data-id="element-211" data-mp="13gm68ndsw96s">
                      <a href={business.mapsLink} target="_blank" rel="noopener noreferrer" className="text-[15px] font-semibold text-ink underline decoration-accent underline-offset-4" data-id="element-212" data-mp="13hnjmyiah7ro">
                        Route plannen via Google Maps
                      </a>
                    </dd>
                  </div>
                </div>

                <div className="flex gap-5 py-6" data-id="element-213" data-mp="frjeuntd71z3">
                  <PhoneIcon className="mt-1 h-5 w-5 shrink-0 text-accent" aria-hidden="true" data-id="element-214" data-mp="fqrts6xe8mn2" />
                  <div data-id="element-215" data-mp="2rd23qc7c6hu3">
                    <dt className="text-[13px] uppercase tracking-[0.14em] text-ink-mute" data-id="element-216" data-mp="2rcjzasaisxb3">Telefoon</dt>
                    <dd className="mt-2 text-[17px] text-ink" data-id="element-217" data-mp="2w76buysc8vwr">
                      <a href={`tel:${business.phoneLink}`} className="underline decoration-accent underline-offset-4" data-id="element-218" data-mp="2hhrylfln5uc3">
                        {business.phoneDisplay}
                      </a>
                    </dd>
                  </div>
                </div>

                <div className="flex gap-5 py-6" data-id="element-219" data-mp="3f4r1i82xfyif">
                  <MailIcon className="mt-1 h-5 w-5 shrink-0 text-accent" aria-hidden="true" data-id="element-220" data-mp="3f3fxc75kkoqs" />
                  <div data-id="element-221" data-mp="313wthqjsjzka">
                    <dt className="text-[13px] uppercase tracking-[0.14em] text-ink-mute" data-id="element-222" data-mp="316sn52olw22x">E-mail</dt>
                    <dd className="mt-2 text-[17px] text-ink" data-id="element-223" data-mp="357w4xuq7s86s">
                      <a href={`mailto:${business.email}`} className="underline decoration-accent underline-offset-4" data-id="element-224" data-mp="1pnpy746lovv7">
                        {business.email}
                      </a>
                    </dd>
                  </div>
                </div>

                <div className="flex gap-5 py-6" data-id="element-225" data-mp="2557tzqeegjha">
                  <GlobeIcon className="mt-1 h-5 w-5 shrink-0 text-accent" aria-hidden="true" data-id="element-226" data-mp="20998qbodbhl3" />
                  <div data-id="element-227" data-mp="1v9wcj0blwy5u">
                    <dt className="text-[13px] uppercase tracking-[0.14em] text-ink-mute" data-id="element-228" data-mp="1vapku5q7rvq3">Officiële website</dt>
                    <dd className="mt-2 text-[17px] text-ink" data-id="element-229" data-mp="2sw3oiva8pss8">
                      <a href={business.website} target="_blank" rel="noopener" className="underline decoration-accent underline-offset-4" data-id="element-230" data-mp="2nytt8z066mwh">
                        {business.websiteLabel}
                      </a>
                    </dd>
                  </div>
                </div>

                <div className="flex gap-5 py-6" data-id="element-231" data-mp="13gvu7dc01mg6">
                  <InstagramIcon className="mt-1 h-5 w-5 shrink-0 text-accent" aria-hidden="true" data-id="element-232" data-mp="13kbcep0yzblt" />
                  <div data-id="element-233" data-mp="3f3h9l8jdt2qk">
                    <dt className="text-[13px] uppercase tracking-[0.14em] text-ink-mute" data-id="element-234" data-mp="3j6dw3ac1lizs">Instagram</dt>
                    <dd className="mt-2 text-[17px] text-ink" data-id="element-235" data-mp="3o5guibxioqys">
                      <a href={business.instagram} target="_blank" rel="noopener noreferrer" className="underline decoration-accent underline-offset-4" data-id="element-236" data-mp="3o45oe5gln74i">
                        {business.instagramLabel}
                      </a>
                    </dd>
                  </div>
                </div>

                <div className="flex gap-5 py-6" data-id="element-237" data-mp="fpx2fg8l1elb">
                  <ClockIcon className="mt-1 h-5 w-5 shrink-0 text-accent" aria-hidden="true" data-id="element-238" data-mp="fpnavo7w2zdi" />
                  <div className="w-full" data-id="element-239" data-mp="2ck07dvpjbsfa">
                    <dt className="text-[13px] uppercase tracking-[0.14em] text-ink-mute" data-id="element-240" data-mp="2hhjy3v3f5xo4">Openingstijden</dt>
                    <dd className="mt-3" data-id="element-241" data-mp="3ks62s10248ex">
                      <ul className="max-w-sm divide-y divide-line" data-id="element-242" data-mp="3kt8x6iwl8szl">
                        {business.hours.map(entry => <li key={entry.day} className="flex items-center justify-between gap-6 py-2 text-[16px]" data-id="element-243" data-mp="3fvfmbckcbasz">
                            <span className="text-ink-soft" data-id="element-244" data-mp="3ou14v7ptaptr">{entry.day}</span>
                            <span className={entry.open ? 'text-ink' : 'text-ink-mute'} data-id="element-245" data-mp="3ow5iihdij378">{entry.time}</span>
                          </li>)}
                      </ul>
                    </dd>
                  </div>
                </div>

                <div className="flex gap-5 py-6" data-id="element-246" data-mp="gd6c4l2qalte">
                  <span className="mt-1 h-5 w-5 shrink-0 text-center font-display text-[13px] font-600 text-accent" data-id="element-247" data-mp="gg28w62ub4g9">
                    KVK
                  </span>
                  <div data-id="element-248" data-mp="qcx52ibn4srd">
                    <dt className="text-[13px] uppercase tracking-[0.14em] text-ink-mute" data-id="element-249" data-mp="qa2m6v89zg02">KVK-nummer</dt>
                    <dd className="mt-2 text-[17px] text-ink" data-id="element-250" data-mp="lbhlkup42ub3">{business.kvk}</dd>
                  </div>
                </div>
              </dl>
            </div>

            <div data-id="element-251" data-mp="19wvz2e8527sg">
              <div className="bg-ink p-8 text-white md:p-10" data-id="element-252" data-mp="19xfi5y9iz282">
                <h2 className="font-display text-2xl font-700 leading-tight tracking-tightest md:text-[30px]" data-id="element-253" data-mp="uzwn6e697ss6">
                  Direct contact opnemen
                </h2>
                <p className="mt-4 text-[17px] leading-relaxed text-white/75" data-id="element-254" data-mp="m8wc7pdy71j5">
                  Vertel ons kort om welk type ruimte het gaat, welke raammaten er zijn en of de gordijnen
                  handbediend, elektrisch of gemotoriseerd moeten worden. Met die gegevens kunnen wij meteen
                  inhoudelijk reageren.
                </p>
                <div className="mt-8 flex flex-col gap-3" data-id="element-255" data-mp="h9t764xywvb6">
                  <a href={`mailto:${business.email}?subject=Aanvraag%20gordijnrails&body=Type%20ruimte%3A%0ARaammaten%3A%0AGewenste%20bediening%3A%0APlanning%3A`} className="inline-flex items-center justify-center gap-2 bg-accent px-6 py-4 text-[15px] font-semibold text-white transition-colors hover:bg-accent-dark" data-id="element-256" data-mp="39id6t1d30ls">
                    <MailIcon className="h-4 w-4" aria-hidden="true" data-id="element-257" data-mp="dsf5n6ym3of7" />
                    Mail naar {business.email}
                  </a>
                  <a href={`tel:${business.phoneLink}`} className="inline-flex items-center justify-center gap-2 border border-white/40 px-6 py-4 text-[15px] font-semibold text-white transition-colors hover:bg-white hover:text-ink" data-id="element-258" data-mp="8ssrmvaym45c">
                    <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-259" data-mp="3r8mvr8a70hwe" />
                    Bel {business.phoneDisplay}
                  </a>
                  <a href={business.instagram} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 border border-white/20 px-6 py-4 text-[15px] font-semibold text-white/85 transition-colors hover:border-white/50 hover:text-white" data-id="element-260" data-mp="3m6e3yf923lvv">
                    <InstagramIcon className="h-4 w-4" aria-hidden="true" data-id="element-261" data-mp="1wpsbcd16hnch" />
                    Volg ons op Instagram
                  </a>
                </div>
              </div>

              <figure className="mt-8" data-id="element-262" data-mp="26ohojsi4qjme">
                <img src={images.interiorSheer} alt="Rustige ruimte met een lange vitrage langs een raampartij en een fauteuil" className="h-72 w-full object-cover md:h-80" loading="lazy" width={1200} height={1200} data-id="element-263" data-mp="26n6p24vpvy13" />
                <figcaption className="mt-2 text-[13px] text-ink-mute" data-id="element-264" data-mp="1nqyfiovo90zz">
                  Illustratief interieurbeeld — geen specifiek project.
                </figcaption>
              </figure>
            </div>
          </div>
        </div>
      </section>

      <section className="border-b border-line bg-canvas" aria-labelledby="locatie" data-id="element-265" data-mp="v817xvuu9wxy">
        <div className="mx-auto max-w-shell px-6 py-16" data-id="element-266" data-mp="oxccttlks1pm">
          <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between" data-id="element-267" data-mp="tvvxlqofn7ge">
            <div data-id="element-268" data-mp="yvibm2c34rq9">
              <h2 id="locatie" className="font-display text-2xl font-700 tracking-tightest text-ink md:text-[32px]" data-id="element-269" data-mp="yx36jt2bacon">
                Onze locatie in Amersfoort
              </h2>
              <p className="mt-3 max-w-2xl text-[17px] leading-relaxed text-ink-soft" data-id="element-270" data-mp="68xjv0rp6dm6">
                Wij zijn gevestigd aan de {business.address.street} in {business.address.city}, provincie{' '}
                {business.address.region}. Bezoek gaat altijd op afspraak, zodat er iemand beschikbaar is die uw
                project kan doornemen.
              </p>
            </div>
            <a href={business.mapsLink} target="_blank" rel="noopener noreferrer" className="inline-flex shrink-0 items-center gap-2 border border-ink px-6 py-3.5 text-[15px] font-semibold text-ink transition-colors hover:bg-ink hover:text-white" data-id="element-271" data-mp="3jlhgg2xu2kon">
              Open in Google Maps
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-272" data-mp="1wp15zuowjlkc" />
            </a>
          </div>
          <div className="mt-10 border border-line bg-white p-2" data-id="element-273" data-mp="1rqgd6gbzc45x">
            <iframe title={`Kaart met de locatie van ${business.name} aan de ${business.address.street} in ${business.address.city}`} src={business.mapsEmbed} className="h-[380px] w-full md:h-[460px]" loading="lazy" referrerPolicy="no-referrer-when-downgrade" data-id="element-274" data-mp="1rsapj696qnye" />
          </div>
        </div>
      </section>

      <section className="border-b border-line bg-white" aria-labelledby="verder" data-id="element-275" data-mp="191jjadkhvdo8">
        <div className="mx-auto max-w-shell px-6 py-14" data-id="element-276" data-mp="1403zeou1zd7f">
          <h2 id="verder" className="font-display text-2xl font-700 tracking-tightest text-ink md:text-[28px]" data-id="element-277" data-mp="z1sm244jukkg">
            Verder op deze site
          </h2>
          <ul className="mt-7 grid gap-5 md:grid-cols-3" data-id="element-278" data-mp="pcltxo8o2ejy">
            {[{
            to: '/diensten',
            title: 'Onze gordijnrails',
            text: 'Gordijnrailsystemen, elektrische en gemotoriseerde rails, zorg en commercieel.'
          }, {
            to: '/over-ons',
            title: 'Over Goelst International',
            text: 'Achtergrond sinds 1978 en onze focus op precisie en integratie.'
          }, {
            to: '/resources',
            title: 'Resources',
            text: 'Gecontroleerde bedrijfsprofielen, kaartvermeldingen en mediakanalen.'
          }].map(card => <li key={card.to} className="border-t-2 border-ink pt-5" data-id="element-279" data-mp="zcckxfy0qbfa">
                <h3 className="font-display text-[19px] font-600 text-ink" data-id="element-280" data-mp="za04x8btmb4v">
                  <Link to={card.to} className="transition-colors hover:text-accent" data-id="element-281" data-mp="13c4zc9a3fbsk">
                    {card.title}
                  </Link>
                </h3>
                <p className="mt-2 text-[16px] leading-relaxed text-ink-soft" data-id="element-282" data-mp="1vu8vho10v264">{card.text}</p>
              </li>)}
          </ul>
        </div>
      </section>
    </>;
}